// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"b473b357","32":"63b4a26e","62":"03c5b6fd","96":"5f1ded30","172":"6e429fc1","195":"eb7e63e8","229":"7192ef64","295":"f10fc6de","400":"8a2be624","695":"ad11cc7b","923":"d858baf8","984":"f8e50703"}[chunkId] + ".chunk.js";
};